import React, { Component } from 'react';
import { FormGroup, Input, Button, Container, FormFeedback } from 'reactstrap';
import { Link } from 'react-router-dom';
import { ArrowBack, CurveTop, ArrowRight, Logo, IconLike } from '../../assets/icons/svgIcon';
import { SvgAssets } from '../../assets/icons/iconSvg';
import c from '../../constants/Colors';
import { getTyC, solicitarAcceso } from '../../store/sagas/authApi';
import Spinner from "../reusable/Loader";
import { notificacion } from '../../utilitarios/util';

function SendEmail({ dadComponent }) {
  const { loading, terminos, tyc, errors, email, ruc, cel,errorCelular, errorRuc, errorsGeneral} = dadComponent.state;

  const attrInput = (errors) ? { invalid: true } : {};
  const attrInputRuc = (errorRuc) ? { invalid: true } : {};
  const attrInputCel = (errorCelular) ? { invalid: true } : {};
  const attrInputGeneral = (errorsGeneral) ? { invalid: true } : {};

  return (
    <div>
      <div className="card text-center card_container solicitar_acceso">
        <img className='logo-small' src={require('../../assets/img/logo-1.png')} />
        <p className="paragraph-1 mb-4" style={{ color: '#8A8A8A' }}>Ingrese su email registrado en Crosland</p>
        <form>
          <FormGroup style={{ marginBottom: 16 }}>
            <Input {...attrInput} className={`naranja ${errors ? " ph-error" : ""}`} type="text" name="email" placeholder="Email"
              value={email}
              onChange={(email) => dadComponent.setEmail(email.target.value)}
              onKeyup={(cel) => dadComponent.setEmail(cel.target.value)}
            />
            {
              errors ? <FormFeedback>{errors}</FormFeedback> : null
            }
          </FormGroup>
          <FormGroup style={{ marginBottom: 16 }}>
            <Input {...attrInputRuc} className={`naranja ${errorRuc ? " ph-error" : ""}`} type="text" name="ruc" 
              placeholder="RUC"
              maxlength="11"
              value={ruc}
              onChange={(ruc) => dadComponent.setRuc(ruc.target.value)}
              onKeyup={(ruc) => dadComponent.setRuc(ruc.target.value)}
            />
            {
              errorRuc ? <FormFeedback>{errorRuc}</FormFeedback> : null
            }
          </FormGroup>
          <FormGroup style={{ marginBottom: 16 }}>
            <Input {...attrInputCel} className={`naranja ${errorCelular ? " ph-error" : ""}`} type="text" name="cel" placeholder="N° Celular"
              value={cel}
              maxlength="9"
              onKeyup={(cel) => dadComponent.setCel(cel.target.value)}
              onChange={(cel) => dadComponent.setCel(cel.target.value)}
            />
            {
              errorCelular ? <FormFeedback>{errorCelular}</FormFeedback> : null
            }
          </FormGroup>
          {
              errorsGeneral ? <FormFeedback className="pl-0">{errorsGeneral}</FormFeedback> : null
          }
          <div className="custom-control custom-radio custom-control-inline terminos">
            <input type="radio" id="radio1" name="radio_ln" className="custom-control-input"
              checked={terminos}
              onChange={() => dadComponent.setTerminos(true)}
            />
            <label className="custom-control-label naranja" htmlFor="radio1">
              Acepto los <a href="#" onClick={(e) => { e.preventDefault(); dadComponent.loadInBrowser() }}>Términos y Condiciones y Políticas de Privacidad.</a>
            </label>
          </div>
        </form>
        <button className={`btn-block${!terminos ? " disabled" : ""}`} style={{ backgroundColor: '#FF9446' }}
          onClick={() => dadComponent.postSolicitarAcceso()}
          disabled={!terminos}
        >
          Solicitar acceso<SvgAssets className='svg-right' icon="icon-arrow-right" fill="#fff" />
        </button>
      </div>
      <div className="link-sa">
        <span>Si ya cuenta con acceso,</span>
        {/* <Link className="link-u" to="/">Iniciar sesión</Link> */}
        <Link className="link-u" to={{ pathname: '/', state: { step: 1 } }}>Iniciar sesión</Link>
      </div>
    </div>
  )
}

function Message({ dadComponent }) {
  const { email } = dadComponent.state;
  return (
    <div>
      <h4 className="text-center title-2 desktop verde"><IconLike className='mr-2' />¡Muchas Gracias!</h4>
      <div className="card text-center card_container">
        <h4 className="text-center title-2 mobile verde"><IconLike className='icon-block' />¡Muchas <br /> Gracias!</h4>
        <p className="paragraph-1 mb-0 text-center verde">
          {/* Hola <strong>Mónica</strong>, muchas gracias por solicitar tu acceso,<br className="desktop" /> en un máximo de 24 horas nos comunicaremos contigo.</p> */}
          Hola, muchas gracias por solicitar tu acceso,<br className="desktop" /> en un máximo de 24 horas nos comunicaremos contigo.</p>
        <div className="text-center mt-5">
          <Link to={{ pathname: '/', state: { step: 1 } }} style={{ textDecoration: 'none' }}>
            <button className='btn-block red'>entendido</button>
          </Link>
        </div>
      </div>
    </div>
  )
}

export class SolicitarAcceso extends Component {
  static displayName = SolicitarAcceso.name;

  constructor(props) {
    super(props);

    this.state = {
      step: 0,
      loading: false,
      terminos: false,
      email: '',
      ruc: null,
      cel: null,
      tyc: null,
      errors: null,
      errorsGeneral: null,
      errorRuc: null,
      errorCelular: null,
      showAlert: false,
      alertTitulo: "",
      alertMensaje: "",
      // password1: false,
      // password2: false
    };
    // this.nextStep = this.nextStep.bind(this);
    // this.backStep = this.backStep.bind(this);
    // this.togglePassword1 = this.togglePassword1.bind(this);
    // this.togglePassword2 = this.togglePassword2.bind(this);
  }

  nextStep() {
    this.setState({ step: this.state.step + 1 })
  }

  backStep() {
    this.setState({ step: this.state.step - 1 })
  }

  // togglePassword1() {
  //   this.setState({ password1: !this.state.password1 })
  // }
  // togglePassword2() {
  //   this.setState({ password2: !this.state.password2 })
  // }

  load = async () => {
    this.setState({
      loading: false,
      terminos: false,
      email: null,
      errors: null
    });
  }

  componentDidMount() {
    this.postTyC();
  }

  renderStep() {
    switch (this.state.step) {
      case 0:
        return <SendEmail dadComponent={this} />
      case 1:
        return <Message dadComponent={this} />
      default:
        return <SendEmail dadComponent={this} />
    }
  }

  render() {
    const { step, loading } = this.state;
    return (
      <div className="login_section" style={{ backgroundImage: 'none' }}>
        <Spinner visible={loading} />
        <Container className="py-5">
          <button className="btn-back mobile"
            onClick={() => { step == 0 ? this.props.history.push('/') : this.backStep() }}
          >
            <SvgAssets icon="icon-back" fill="#fff" />
          </button>
          {this.renderStep()}
        </Container>
      </div>
    );
  }

  notificacion = async (alertTitulo = "", alertMensaje = "") => {
    this.setState({ alertTitulo, alertMensaje });
    this.toggleModalAlert();
  }

  toggleModalAlert = () => {
    this.setState(prevState => ({
      showAlert: !prevState.showAlert,
    }));
  }

  setTerminos = (value) => {
    this.setState({ terminos: value })
  }

  setEmail = (value) => {
   
    const re = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
    this.setState({ email: value, errors: null, errorsGeneral:null })
    console.log("test: ",re.test(value))
    if(re.test(value)){
      console.log("entrro en true")
    }
    else{
      this.setState({ errors: "Por favor ingrese un Email válido" })
    }
    
    if(value === ''){
      this.setState({ errors: null })
    }
  }
  
  setRuc = (value) => {
    let de = /[^0-9]/g;
    value = value.replace(de,"");
    this.setState({ ruc: value, errorRuc: null,errorsGeneral:null })
  }
  setCel = (value) => {
    let de = /[^0-9]/g;
    value = value.replace(de,"");
    this.setState({ cel: value, errorCelular: null ,errorsGeneral:null })    
    if(de.test(value)){
      this.setState({  errorCelular: null }) 
    }

  }
  loadInBrowser = () => {
    if (this.state.tyc != null)
      window.open(this.state.tyc);
  };

  postTyC = async () => {
    getTyC()
      .then(result => {
        if (result.mo.type === "success") {
          this.setState({ loading: false, tyc: result.dto.urlTyC })
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          notificacion("Login", error.message ?? null);
        });
      });

  }

  postSolicitarAcceso = async () => {
    //debugger;
    let strEmail = this.state.email == null || this.state.email === undefined ? "" : this.state.email.trim()
    let strRuc = this.state.ruc == null || this.state.ruc === undefined ? "" : this.state.ruc.trim()
    let strCel = this.state.cel == null || this.state.cel === undefined ? "" : this.state.cel.trim()

    let flag = true;
    if (strEmail === "" || strEmail == null){
      this.setState({ errors: "Debe ingresar un Email" });
      flag= false;
    }
    if (strRuc === "" || strRuc == null || strRuc.length !== 11){
      this.setState({ errorRuc: "Debe ingresar el Ruc, debe tener 11 números" })
      flag= false;
    }
    if (strCel === "" || strCel == null ||  strCel.length !== 9){
      this.setState({ errorCelular: "Debe ingresar un valor de 9 números" })  
      flag= false;
    }
    else if (!this.state.terminos){
      this.setState({ errors: "Debe aceptar los términos y condiciones" })
      flag= false;
    }
      
    if(flag) {
      this.setState({ loading: true }) 
      solicitarAcceso(strEmail, strRuc, strCel)
        .then(result => {
          this.setState({ loading: false })
          if (result.mo.type == "success") {
            this.setState({ email: strEmail }, () => {
              this.nextStep();
            })
            // this.props.navigation.navigate('AuthMensaje', { email: this.state.email });
          } else {
            this.setState({ loading: false })
            result.mo.listMessage.map(item => {
              if(item.includes("Correo")||item.includes("Email")){
                this.setState({  errors: item })
              }
              if(item.includes("Cel")){
                this.setState({  errorCelular: item })
              }
              if(item.includes("Ruc") || item.includes("RUC")){
                this.setState({  errorRuc: item })
              }              
              else if(item.includes("Cliente") && item.includes("error")) {
                this.setState({  errorsGeneral: item })
              }
            })
          }
        }).catch((error) => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          this.setState({ loading: false }, async () => {
            // await this.notificacion("Solicitar Acceso", error.message ?? null);
            notificacion("Solicitar Acceso", error.message ?? null);
          });
        });
    }
  }
}
